// Shared chart style tokens for the dashboard
import { CHART } from "../../../lib/constants";

export const CHART_HEIGHT = "h-72";
export const PIE_INNER = CHART.pieInner;
export const PIE_OUTER = CHART.pieOuter;
export const AXIS_TICK = CHART.axis;
export const AXIS_STROKE = CHART.axisStroke;
export const GRID_STROKE = CHART.gridStroke;
export const TOOLTIP_STYLE = CHART.tooltip;

export const SOURCE_COLORS = [
  "#8b5cf6", "#6366f1", "#3b82f6", "#06b6d4", "#14b8a6",
  "#10b981", "#f59e0b", "#ef4444", "#ec4899", "#a855f7",
];

export const SOURCE_COLORS_MAP = {
  "HuggingFace Spaces": "#3b82f6",
  "Apple App Store": "#a3a3a3",
  "HuggingFace Models": "#6366f1",
  "TAAFT / Kaggle": "#f59e0b",
  "Google Play Store": "#ec4899",
  "Futurepedia": "#10b981",
  "Product Hunt": "#f97316",
  "Web Research": "#06b6d4",
  "Global Expansion": "#8b5cf6",
  "FDA Cleared Devices": "#ef4444",
  "CES / Trade Shows": "#14b8a6",
  "Research Labs": "#6366f1",
  "Robotics Databases": "#0ea5e9",
  "AI-Assisted Research": "#a78bfa",
  "Curated / Expert": "#d946ef",
  "Policy / NGO": "#22d3ee",
  "Targeted Scraping": "#fb923c",
  "Other Sources": "#6b7280",
};

export const GOVERNANCE_COLORS = {
  "participatory": "#10b981",
  "neutral": "#3b82f6",
  "market_first": "#f59e0b",
  "system_aware": "#8b5cf6",
  "unknown": "#6b7280",
};
